import { useMaterialSpecAssets } from "./useMaterialSpecAssets";

export const useAdMaterialVisual = (isPrinted: boolean, materialSpecId?: number, materialId?: number) => {
    const { data: assets } = useMaterialSpecAssets(
        { isPrinted, materialId: isPrinted ? undefined : materialId, materialSpecId },
        true
    );

    return assets?.find((asset) => asset.type === "VISUAL");
};
